import React, { Component, Fragment } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";
import {standardActions} from '../../../Utils/Grid/StandardActions';
import moment from 'moment';
import { api } from '../../../../../utility/api';
let url = 'valesGasolina';

const getAllValesGasolina = (params) => {
    return api.get(`${url}/reporteVales`, params)
        .then((data) => {
            if (data) return data.results ? data.results : data;
            return [];
        })
        .catch(() => {
            return [];
        });
};

export default class GridGastos extends Component {

    state = {
        rows_seleccionado: [],
        seleccionados_default: [],
    }

    componentDidMount() {
        //this.props.listarGastos();
        this.props.listar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            if (this.props.is_all_selected) {
                let _rows_seleccionados = _.cloneDeep(this.state.rows_seleccionado);
                const nuevasFilas = _.differenceBy(this.props.data.results, _rows_seleccionados, 'id');
                const rowsActualizados = [..._rows_seleccionados, ...nuevasFilas];
                const idsActualizados = _.map(rowsActualizados, 'id');

                this.setState({
                    rows_seleccionado: rowsActualizados,
                    seleccionados_default: idsActualizados
                });
                this.props.setTarjetaSeleccionados(rowsActualizados);
            } else {
                const idsSeleccionados = _.map(this.state.rows_seleccionado, 'id');
                const seleccionados_en_pagina = _.intersection(idsSeleccionados, _.map(this.props.data.results, 'id'));
                this.setState({seleccionados_default: seleccionados_en_pagina});
            }
        }
    }

    onRowSelect = (row, isSelected) => {
        let _rows_seleccionados = _.cloneDeep(this.state.rows_seleccionado);
        const _row =  _.find(_rows_seleccionados, (x) => {
            return row.id == x.id;
        });
        if(_row){
            _.remove(_rows_seleccionados, (x) => {
                return x == _row;
            })
            let array_nuevo = _.cloneDeep(this.state.seleccionados_default);
            _.remove(array_nuevo, (x) => {
                return row.id == x
            })
            this.setState({
                rows_seleccionado: [..._rows_seleccionados],
                seleccionados_default: array_nuevo,
            })
            this.props.setTarjetaSeleccionados([..._rows_seleccionados])
            this.props.setIsAllSelected(false);
        }else{
            this.setState({
                rows_seleccionado: [..._rows_seleccionados, row],
                seleccionados_default: [...this.state.seleccionados_default, row.id]
            })
            this.props.setTarjetaSeleccionados([..._rows_seleccionados, row])
        }

    }

    onSelectAll = (isSelect, rows) => {
        if (!isSelect) {
            this.setState({
                rows_seleccionado: [],
                seleccionados_default: [],
            });
            this.props.setTarjetaSeleccionados([]);
            this.props.setIsAllSelected(false);
            return;
        }


        this.props.setLoader(true);
        let params = {};
        if (this.props.vehiculo) params.vehiculo = this.props.vehiculo.id;
        if (this.props.empresa) params.empresa = this.props.empresa.value;
        if (this.props.search) params.search = this.props.search;
        if (this.props.dias) params.dia_pago = this.props.dias.value;
        if (this.props.fecha_inicio) params.fecha_inicial = moment(this.props.fecha_inicio).format("YYYY-MM-DD")
        if (this.props.fecha_fin) params.fecha_final = moment(this.props.fecha_fin).format("YYYY-MM-DD")
        getAllValesGasolina(params).then((results) => {
            const newRows = results ? results : [];
            const newRowsIds = _.map(newRows, 'id');
            const total_select = results.reduce((acumulador, item) => {
                return acumulador + item.total;
            }, 0);

            this.setState({
                rows_seleccionado: newRows,
                seleccionados_default: newRowsIds,
            });
            this.props.setTarjetaSeleccionados(newRows);
            this.props.setIsAllSelected(true);
            this.props.setLoader(false);
        });
    };


    render() {
        const { loader, data, page, listar, onPageChange, onSortChange} = this.props;
        var selectRowProp = {
            mode: "checkbox",
            clickToSelect: true,
            onSelect: this.onRowSelect,
            selected: this.state.seleccionados_default,
            onSelectAll: this.onSelectAll
        };

        return (
            <Fragment>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    page={page}
                    className="reporte-table"
                    onPageChange={listar} onSortChange={onSortChange}
                    selectRowProp={selectRowProp}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="id"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell)=>(
                                cell ? '' : ''
                            )
                            //standardActions({  eliminarModal: this.props.abrirModalEliminar })
                        }
                        width="10%"
                    />
                    <TableHeaderColumn
                        dataField="vehiculo"
                        dataSort
                        className='reporte-table'
                        width="28%"
                        dataFormat={(cell, row) => (
                            <div>
                                <Fragment>
                                    <span className="font-weight-bold">Tipo: </span>
                                    <span style={{ color: "black" }} >{cell.tipo == 1 ? 'Vehículo' : 'Maquinaria'}</span>
                                    <br />
                                </Fragment>
                                <Fragment>
                                    <span className="font-weight-bold">Placa: </span>
                                    <span style={{ color: "black" }} >{cell.placa}</span>
                                    <br />
                                </Fragment>
                            </div>
                        )}
                    >
                        VEHÍCULO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="km_vehiculo"
                        dataSort
                        className='reporte-table'
                        // width="14%"
                        dataFormat={(cell) => cell}
                    >
                        KM VEHÍCULO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="no_factura"
                        dataSort
                        className='reporte-table'
                        // width="14%"
                        dataFormat={(cell) => cell}
                    >4
                        No. FACTURA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha"
                        dataSort
                        className='reporte-table'
                        width="14%"
                        dataFormat={(cell) => moment(cell).format('DD-MM-YYYY')}
                    >
                        FECHA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="galones_gasolina"
                        dataSort
                        className='reporte-table'
                        width="14%"
                        dataFormat={(cell) => ( cell ? cell : "Sin registro")}
                    >
                        GALONES
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total"
                        dataSort
                        className='reporte-table'
                        width="14%"
                        dataFormat={(cell) => ( cell ? <RenderMoneda monto={cell}/> : "Sin registro" )}
                    >
                        MONTO
                    </TableHeaderColumn>
                </Grid>
            </Fragment>
        )
    }

}